import { isNotBlank, isNotNullNorUndefined } from "@/utils/ts-utils"
import { useIntl } from "react-intl"

import { useAppToast } from "./useAppToast"

export const useGenericErrorToast = () => {
  const toast = useAppToast()
  const intl = useIntl()

  return (e?: unknown, v?: unknown, c?: unknown) => {
    const response = isNotNullNorUndefined(e) && "response" in e ? e?.response : undefined
    const responseMessage =
      isNotNullNorUndefined(response) &&
      "data" in response &&
      isNotNullNorUndefined(response.data) &&
      "hydra:description" in response.data
        ? (response.data["hydra:description"] as string)
        : undefined

    const errorMessage =
      isNotNullNorUndefined(e) && "message" in e ? (e?.message as string) : undefined

    return toast({
      status: "error",
      title: isNotBlank(responseMessage)
        ? responseMessage
        : isNotBlank(errorMessage)
          ? errorMessage
          : intl.formatMessage({ id: "error.generic.title" }),
    })
  }
}
